
import { defineComponent, ref, watch } from "vue";
import axios from "@/axios-instance"
import { boolean } from "yup/lib/locale";

interface Filter {
  status: string;
  class12ProvinceId: number;
  class12SchoolId: number;
  prProvinceId: number;
  hasAmount: string;
  month: number;
}

export default defineComponent({
  name: "filter-bar",
  emits: ["filterData", "resetSearch"],
  props: {
    isProfile: { type: Boolean },
    // Đang chọn record ở bảng → ẩn cụm lọc, hàng 1 nhường trọn cho thanh thao tác chọn (slot actions)
    selecting: { type: Boolean, default: false },
    // Ẩn lọc "Hồ sơ nộp": danh sách ứng viên LIÊN THÔNG ai cũng có hồ sơ nên lọc này vô nghĩa
    hideHasAmount: { type: Boolean, default: false },
  },
  components: {},
  computed: {
    // Gộp 2 cờ badmajor + dupidcard vào 1 dropdown "Dữ liệu hồ sơ" (Tất cả / Lỗi ngành / Trùng CCCD) cho gọn.
    // Giá trị UI: 0=Tất cả, 1=Lỗi ngành, 2=Trùng CCCD; map ngược ra 2 cờ thật (vẫn emit/persist như cũ).
    dataIssue: {
      get(): number {
        return (this as any).data.dupidcard ? 2 : ((this as any).data.badmajor ? 1 : 0)
      },
      set(v: any) {
        (this as any).data.badmajor = v === 1 ? 1 : 0;
        (this as any).data.dupidcard = v === 2 ? 1 : 0;
      }
    }
  },
  methods: {
    // Live-apply: gộp các thay đổi liên tiếp trong 300ms thành 1 lần gọi (debounce)
    applyFilterDebounced() {
      clearTimeout((this as any)._filterTimer);
      (this as any)._filterTimer = setTimeout(() => this.applyFilter(), 300);
    },
    async getSchool(code) {
      this.data.class12SchoolId = 0
      let params = ''
      if(code != 0) {
        params = `?pvcode=${code}`
      }
      await axios.get(`/school/${params}`)
      .then(( {data} ) => {
        this.arrSchool = data.map(i => {return {label:i.name,value:i.id}})
        let temp = {
          label: 'Tất cả',
          value: 0,
        }
        this.arrSchool.unshift(temp as never)
      })
    },
    async resetFilter() {
      try { localStorage.removeItem(this.storageKey()) } catch (e) { /* ignore */ }
      this.data = {
        status: "all",
        class12ProvinceId: 0,
        class12SchoolId: 0,
        prProvinceId: 0,
        month: 0,
        hasAmount: 'Tất cả',
        groupAssignee: 0,
        assignee: 0,
        badmajor: 0,
        dupidcard: 0,
        nofile: 0,
        bgdsync: ''
      }
      let filter = JSON.parse(JSON.stringify(this.data))
      filter.school = {
        value: this.data.class12SchoolId,
        lable: 'Tất cả',
      }
      filter.prProvince = {
        value: this.data.prProvinceId,
        lable: 'Tất cả',
      }
      filter.hasAmount = filter.hasAmount == 'Tất cả' ? 2 : filter.hasAmount == 'Có' ? 1 : 0
      if(this.isProfile) {
        this.dataFilterProfile.major = 0
        this.dataFilterProfile.method = 0
        filter = {
          month: this.data.month,
          status: this.data.status,
          major: {
            value: this.dataFilterProfile.major,
            label: 'Tất cả',
          },
          method: {
            value: this.dataFilterProfile.method,
            label: 'Tất cả',
          },
          nofile: 0,
        }
      }
      //await this.authenticated()
      // Đặt lại cũng xoá ô tìm kiếm (ô nằm ở slot trang cha -> báo cha tự xoá)
      this.$emit('resetSearch')
      this.$emit('filterData',filter)
    },
    async applyFilter() {
      let filter = JSON.parse(JSON.stringify(this.data))

      if(!this.isProfile) {
        let class12SchoolId = this.arrSchool.filter((item:{label:string;value:number}) =>item.value == this.data.class12SchoolId)[0] as {label:string;value:number}
        let prProvinceId = this.arrProvince.filter((item:{label:string;value:number}) =>item.value == this.data.prProvinceId)[0] as {label:string;value:number}
        let class12ProvinceId = this.arrProvinceForSchool.filter((item:{label:string;value:number;id:number}) =>item.value == this.data.class12ProvinceId)[0] as {label:string;value:number;id:number}
        filter.hasAmount = filter.hasAmount == 'Tất cả' ? 2 : filter.hasAmount == 'Có' ? 1 : 0

        // ?. : khi đổi "Địa phương" thì danh sách trường đang nạp lại → mảng có thể tạm rỗng, tránh crash live-apply
        filter.class12ProvinceId = class12ProvinceId?.id ?? 0
        filter.school = {
          value: this.data.class12SchoolId,
          label: (class12SchoolId?.label ?? '') + ' - ' + (class12ProvinceId?.label ?? ''),
        }
        filter.prProvince = {
          value: this.data.prProvinceId,
          label: prProvinceId?.label ?? '',
        }
      }

      if(this.isProfile) {
        let major = this.arrMajors.filter((item:{label:string;value:number}) =>item.value == this.dataFilterProfile.major)[0] as {label:string;value:number}
        filter = {
          month: this.data.month,
          status: this.data.status,
          major: {
            value: this.dataFilterProfile.major,
            label: major?.label,
          },
          method:  {
            value: this.dataFilterProfile.method,
            label: this.arrMethods.filter(item =>item.value == this.dataFilterProfile.method)[0]?.label ?? '',
          },
          nofile: this.data.nofile,
        }
      }
      //await this.authenticated()
      filter.groupAssignee = this.data.groupAssignee == 'Tất cả' ? 0 : this.data.groupAssignee
      filter.assignee = this.data.assignee == 'Tất cả' ? 0 : this.data.assignee

      this.saveFilter()
      this.$emit('filterData',filter)
    },
    // Lọc nhanh "Lỗi ngành" — gọi từ banner cảnh báo ở Danh sách ứng viên
    applyBadMajorFilter() {
      this.showAdvanced = true
      if (this.isProfile) {
        this.dataFilterProfile.major = 'badmajor' as any // Danh sách hồ sơ: lỗi ngành chọn qua dropdown Ngành (value 'badmajor'); major vốn number nên cast
      } else {
        this.data.badmajor = 1
        this.data.dupidcard = 0
      }
      this.applyFilter()
    },
    // Lọc nhanh "Trùng CCCD" — gọi từ banner cảnh báo ở Danh sách ứng viên
    applyDupIdCardFilter() {
      this.showAdvanced = true
      this.data.dupidcard = 1
      this.data.badmajor = 0
      this.applyFilter()
    },
    // Lọc nhanh "Chưa có file minh chứng" — gọi từ banner ở Danh sách hồ sơ
    applyNoFileFilter() {
      this.showAdvanced = true
      this.data.nofile = 1
      this.applyFilter()
    },
    // ===== Ghi nhớ bộ lọc qua các lần điều hướng (localStorage theo route) =====
    storageKey() {
      return 'tsFilter:' + (this.isProfile ? 'profile' : 'candidate') + ':' + (window.location.pathname || '')
    },
    saveFilter() {
      try {
        localStorage.setItem(this.storageKey(), JSON.stringify({ data: this.data, dataFilterProfile: this.dataFilterProfile }))
      } catch (e) { /* ignore */ }
    },
    async restoreOrReset() {
      let saved: any = null
      try {
        const raw = localStorage.getItem(this.storageKey())
        if (raw) saved = JSON.parse(raw)
      } catch (e) { saved = null }
      if (!saved || !saved.data) { this.resetFilter(); return }
      this.data = { ...this.data, ...saved.data }
      // Lọc bị ẩn thì không được sống ngầm từ localStorage (lọc vô hình, user không hiểu vì sao thiếu dòng)
      if (this.hideHasAmount) this.data.hasAmount = 'Tất cả'
      if (saved.dataFilterProfile) this.dataFilterProfile = { ...this.dataFilterProfile, ...saved.dataFilterProfile }
      // Khôi phục danh sách trường khi đã chọn Tỉnh/TP (trường L12): getSchool reset class12SchoolId nên set lại sau.
      if (!this.isProfile && this.data.class12ProvinceId) {
        const _school = this.data.class12SchoolId
        await this.getSchool(this.data.class12ProvinceId)
        this.data.class12SchoolId = _school
      }
      this.applyFilter()
    },
    getCookie(name: string): string|null {
      const nameLenPlus = (name.length + 1);
      return document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => {
          return cookie.substring(0, nameLenPlus) === `${name}=`;
        })
        .map(cookie => {
          return decodeURIComponent(cookie.substring(nameLenPlus));
        })[0] || null;
    },
    delete_cookie(name) {
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    setCookie(name,value,days) {
      this.delete_cookie(name)
      let expires = "";
      if (days) {
          let date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },
    async authenticated() {
      let temp = window.localStorage.getItem("user")
      let user = temp?JSON.parse(temp) : null
      let id = user?.id
      if(this.getCookie('accessToken')) {
        await axios.post('/auth2/authenticated',{accessToken: this.getCookie('accessToken'),userId: id})
        .then(( {data} ) => {
          //console.log('data',data)
          if(data.isAuthenticated && data.newAccessToken) {
            this.setCookie('accessToken',data.newAccessToken,30)
          }
        })
        .catch(({ response }) => {
          console.log('err',response)
        });
      }
    },
  },

  async mounted() {
    const temp = window.localStorage.getItem("user")
    this.infUser = temp?JSON.parse(temp) : {} as any
    await axios.get('/user/findusersforselect/')
      .then(( {data} ) => {
        this.arrUsersAssign = data.map(i => {return {label:i.fullName+' / '+i.email,value:i.id}})
        let tempArr = [
        {
          label: 'Tất cả',
          value: 0,
        },
        {
          label: 'Không có',
          value: 'khong_co',
        }
        ]
        this.arrUsersAssign = tempArr.concat(this.arrUsersAssign) as any
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
      await axios.get('/groups/findgroupsforselect/')
      .then(( {data} ) => {
        this.arrGroupsAssign = data.map(i => {return {label:i.groupName+' / '+i.groupCode,value:i.id}})
        let tempArr = [
        {
          label: 'Tất cả',
          value: 0,
        },
        {
          label: 'Không có',
          value: 'khong_co',
        }
        ]
        this.arrGroupsAssign = tempArr.concat(this.arrGroupsAssign) as any
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
    if(!this.isProfile) {
      this.getSchool(0)
      await axios.get('/province/')
      .then(( {data} ) => {
        this.arrProvinceForSchool = data.map(i => {return {label:i.name,value:i.code,id:i.id}})
        let temp = {
          label: 'Tất cả',
          value: 0,
          id: 0,
        }
        this.arrProvinceForSchool.unshift(temp as never)
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
      await axios.get('/res/province/')
      .then(( {data} ) => {
        this.arrProvince = data.map(i => {return {label:i.name,value:i.id}})
        let temp = {
          label: 'Tất cả',
          value: 0,
        }
        this.arrProvince.unshift(temp as never)
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
    }
    if(this.isProfile) {
      await axios.get('/major/')
      .then(( {data} ) => {
        this.arrMajors = data.map(i => {return {label:i.name,value:i.id}})
        let temp = {
          label: 'Tất cả',
          value: 0,
        }
        this.arrMajors.unshift(temp as never)
        // Tìm hồ sơ có ngành bị xoá / chưa chọn (lỗi ngành)
        this.arrMajors.push({ label: '⚠ Lỗi ngành (đã xoá / chưa chọn)', value: 'badmajor' } as never)
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
      // Phương thức: lấy danh mục PT đang bật (id = idAdMethod). Lỗi API thì giữ nguyên
      // 2 mục mặc định (Tất cả / Liên thông) chứ không để dropdown trống.
      await axios.get('/admission/method')
      .then(( {data} ) => {
        const _methods = (data || []).map(i => ({ label: i.shortname || i.name, value: i.id }))
        if (_methods.length > 0) {
          this.arrMethods = [{ label: 'Tất cả', value: 0 }]
            .concat(_methods)
            .concat([{ label: 'Liên thông ĐHCQ', value: 9 }]) as any
        }
      })
      .catch(({ response }) => {
        console.log('err',response)
      });
    }
    await this.restoreOrReset()
  },
  setup() {
    // Nhớ trạng thái mở/đóng "Lọc nâng cao" theo TỪNG trang (localStorage) — chuyển trang quay lại vẫn giữ
    const ADV_KEY = 'umt_filterbar_adv_' + window.location.pathname
    const _savedAdv = localStorage.getItem(ADV_KEY)
    const showAdvanced = ref(_savedAdv != null ? _savedAdv === '1' : true)
    watch(showAdvanced, (v) => { try { localStorage.setItem(ADV_KEY, v ? '1' : '0') } catch (e) { /* storage đầy/ẩn danh — bỏ qua */ } })
    const infUser = ref<any>({})
    const arrSchool = ref<any>([])
    const arrProvince = ref<any>([])
    const arrMajors = ref<any>([])
    const arrGroupsAssign = ref<any>([])
    const arrUsersAssign = ref<any>([])

    const arrProvinceForSchool = ref<any>([])
    // Phương thức = idAdMethod (enum BE) = admission_methods.id, KHÔNG phải methodNo.
    // Nạp từ danh mục thật (GET /admission/method — chỉ PT đang bật) thay vì hardcode: danh sách
    // hardcode cũ giữ cả PT đã tắt ở Cài đặt (vd "Ưu tiên xét tuyển thẳng") và thiếu PT mới.
    // Liên thông (9) không nằm trong danh mục nên nối tay ở cuối.
    const ID_AD_METHOD_LTDHCQ = 9
    const arrMethods = ref<any>([
      { label: 'Tất cả', value: 0 },
      { label: 'Liên thông ĐHCQ', value: ID_AD_METHOD_LTDHCQ },
    ])

    const dataFilterProfile = ref({
      major: 0,
      method: 0,
    })
    const data = ref<any>({
      status: "all",
      class12SchoolId: 0,
      prProvinceId: 0,
      month: 0,
      hasAmount: 'Tất cả',
      class12ProvinceId: 0,
      groupAssignee: "Tất cả",
      assignee: "Tất cả",
      badmajor: 0,
      dupidcard: 0,
      nofile: 0,
      bgdsync: '', //''=Tất cả | transcript | graduationscore | none — đồng bộ điểm với Bộ
    });

    return {
      showAdvanced,
      data,
      dataFilterProfile,
      arrMajors,
      arrSchool,
      arrProvince,
      arrProvinceForSchool,
      arrMethods,
      arrUsersAssign,
      arrGroupsAssign,
      infUser
    };
  },
});
